import {createReducer, on} from '@ngrx/store';
import * as contactsActions from './address-verification-actions';
import * as fromAddress from './address-verification-state';
import {CheckoutInterface} from '@app/marketplace/checkout/_models/checkout.model';
import {ResponseBaseModel} from '@app/marketplace/core/models/response.model';

const initialState: fromAddress.State = {isLoading: false, data: { data: null, message: '', success: false}, updated: null};
export const reducer = createReducer(
  initialState,
  on(contactsActions.LoadingAddress, (state) => {
    return {...state, isLoading: true};
  }),
  on(contactsActions.GetAddress, (state, {data}) => {
    return {...state, isLoading: false, data};
  }),
  on(contactsActions.UpdatingAddress, (state, {payload}) => {
    return {...state, isLoading: true};
  }),
  on(contactsActions.UpdatedAddress, (state, {data})  => {
    return {...state, isLoading: false, updated: data};
  }),
  on(contactsActions.CleaningData, (state)  => {
    return initialState;
  }),
);
